import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';

export function* CheckTestConnection(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.TEST_CONNECTION, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SaveConnection(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SAVE_CONNECTION, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* SyncAccountGroups(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SYNC_ACCOUNT_GROUPS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SyncAccount(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SYNC_ACCOUNT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SyncFinancialBook(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SYNC_FINANCIAL_BOOK, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SyncItemGL(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SYNC_ITEM_GL, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SyncLocation(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SYNC_LOCATION, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SyncDepartment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SYNC_DEPARTMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SyncVendor(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SYNC_VENDOR, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetSyncAccountGroups(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_SYNC_ACCOUNT_GROUPS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetSyncAccount(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_SYNC_ACCOUNT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetSyncFinancialBook(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_SYNC_FINANCIAL_BOOK, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetSyncItemGL(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_SYNC_ITEM_GL, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetSageFacilityList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_SAGE_FACILITY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetSageDepartmentList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_SAGE_DEPARTMENT_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetAssetSubGroupCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_ASSET_SUB_GROUP_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetAssetSubGroupList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_ASSET_SUB_GROUP_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SaveAssetSubGroup(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SAVE_ASSET_SUB_GROUP, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* DeleteAssetGroup(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.SAGE.DELETE_ASSET_GROUP+'?assetSubGroupID='+data?.assetSubGroupID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetAssetMappingList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_ASSET_MAPPING_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveAssetMapping(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SAVE_ASSET_MAPPING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetAssetInventoryMappingList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_ASSET_INVENTORY_MAPPING_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SaveAssetInventoryMapping(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SAVE_ASSET_INVENTORY_MAPPING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetAssetOtherMappingList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_ASSET_OTHER_MAPPING_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SaveAssetOtherMapping(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SAVE_ASSET_OTHER_MAPPING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* PostAssetDisposalToSage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.POST_ASSET_DISPOSAL_TO_SAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* PostAssetRevaluationToSage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.POST_ASSET_REVALUATION_TO_SAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* PostAssetDepreciationToSage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.POST_ASSET_DEPRECIATION_TO_SAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetRefNumberList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_REF_NUMBER_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetDefaultDataSync(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_DEFAULT_DATA_SYNC, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetSageConfig(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_SAGE_CONFIG, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveAssetGroupExpenseAccountMapping(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.SAVE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetAssetGroupExpenseAccountMappingList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_SAGE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* PostAll(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SAGE.POST_ALL, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetUsedAccmDeprAccountList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_USED_ACCUMULATED_DEPRECIATION_ACCOUNT_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetUsedAccountList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.GET_USED_ACCOUNT_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* PostAllStatus(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SAGE.POST_ALL_STATUS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}